import PosthogService from '~/services/posthog/PosthogService';

export function fireMenuBarAccountClicked(): void {
  PosthogService.getInstance().track('dental_portal:menu_bar:account_clicked');
}
